export const ELLIPSIS = '...'

const getPageNumbers = (currentPage, totalPages) => {
  if (totalPages <= 7)
    return Array.from({ length: totalPages }, (_unused, index) => index + 1)

  const pages = new Set([1, totalPages, currentPage])
  if (currentPage > 1)
    pages.add(currentPage - 1)
  if (currentPage < totalPages)
    pages.add(currentPage + 1)

  const sortedPages = [...pages].sort((left, right) => left - right)
  const result = []
  for (let index = 0; index < sortedPages.length; index++) {
    if (index > 0 && sortedPages[index] - sortedPages[index - 1] > 1)
      result.push(ELLIPSIS)
    result.push(sortedPages[index])
  }
  return result
}

export default getPageNumbers
